import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { createAction } from 'utils';
import { loginRedirect } from 'utils/WeChatUtil'
import { strToBool } from 'utils/UrlUtils';

const defaultRedirectTo = '/home';

@connect(({ users }) => ({ ...users }))
class Login extends Component {
  componentDidMount() {
    this.props.dispatch({ type: 'weChat/updateState', payload: { weChatInitialLink: window.location.href.split('#')[0] } })
    const search = this.props.location.search;
    const params = new URLSearchParams(search);
    const code = params.get('token');
    const language = params.get('lang');
    const redirectTo = params.get('redirect_to') || defaultRedirectTo;
    const isEventRegister = strToBool(params.get('is_event_register'));

    if (language) {
      this.props.dispatch({
        type: 'users/updateState',
        payload: { language: language },
      });
    }
    if (isEventRegister) {
      const verifyCredential = params.get('verify_credential');
      const countryCode = params.get('country_code');
      const mobile = params.get('mobile');
      const email = params.get('email');
      this.props.dispatch({
        type: 'users/updateState',
        payload: {
          eventRegistrationData: {
            verifyCredential,
            countryCode,
            phoneNumber: mobile,
            email,
            ignoreLogin: true,
          },
        },
      });
    }
    if (code) {
      // this.props.cookies.remove('user')
      console.log(code);
      this.props.dispatch(
        createAction('users/login')({
          code,
          successAction: () => {
            loginRedirect({
              pathname: redirectTo,
              history: this.props.history,
              params: { backToHome: true }
            })
          },
          failAction: () => {
            loginRedirect({
              pathname: defaultRedirectTo,
              history: this.props.history,
            })
          },
        }),
      );
    } else {
      loginRedirect({
        pathname: redirectTo,
        history: this.props.history,
        params: { backToHome: true }
      })
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      loginRedirect({
        pathname: defaultRedirectTo,
        history: this.props.history,
      })
    }
  }

  render() {
    return (
      <div>
        {/* <pre id="content">
                    loading..
                </pre> */}
      </div>
    );
  }
}

export default withRouter(Login);
